/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `READY_FOR_PROCESSING` - Ready For Processing
 * * `IMPORTING` - Importing
 * * `ERROR` - Error
 * * `WAITING_APPROVAL` - Waiting Approval
 * * `COMPLETE` - Complete
 * * `TIMED_OUT` - Timed Out
 * @export
 */
export const DataImportStatusEnum = {
    Created: 'CREATED',
    ReadyForProcessing: 'READY_FOR_PROCESSING',
    Importing: 'IMPORTING',
    Error: 'ERROR',
    WaitingApproval: 'WAITING_APPROVAL',
    Complete: 'COMPLETE',
    TimedOut: 'TIMED_OUT'
} as const;
export type DataImportStatusEnum = typeof DataImportStatusEnum[keyof typeof DataImportStatusEnum];


export function instanceOfDataImportStatusEnum(value: any): boolean {
    for (const key in DataImportStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(DataImportStatusEnum, key)) {
            if (DataImportStatusEnum[key as keyof typeof DataImportStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataImportStatusEnumFromJSON(json: any): DataImportStatusEnum {
    return DataImportStatusEnumFromJSONTyped(json, false);
}

export function DataImportStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportStatusEnum {
    return json as DataImportStatusEnum;
}

export function DataImportStatusEnumToJSON(value?: DataImportStatusEnum | null): any {
    return value as any;
}

export function DataImportStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DataImportStatusEnum {
    return value as DataImportStatusEnum;
}

